import React, { useCallback, useState } from 'react';
import { useBillingT } from '../hooks/useQuotesT';
import './BillingModuleUnavailable.css';

import { BuildOutlined, MailOutline, Smartphone } from '@mui/icons-material';
const SUPPORT_EMAIL = 'contact@rintintin.fr';

/**
 * Écran affiché quand BILLING_MODULE est coupé (kill-switch).
 * La nav Facturation reste visible — on n’« efface » pas la zone.
 */
const BillingModuleUnavailable: React.FC = () => {
  const t = useBillingT();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRetry = useCallback(() => {
    setIsRefreshing(true);
    window.location.reload();
  }, []);

  return (
    <div className="billing-module-unavailable" role="status" aria-live="polite">
      <div className="billing-module-unavailable__card">
        <div className="billing-module-unavailable__badge">
          <BuildOutlined aria-hidden />
          <span>{t('moduleUnavailable.status')}</span>
        </div>

        <h1 className="billing-module-unavailable__title">
          {t('moduleUnavailable.title')}
        </h1>

        <p className="billing-module-unavailable__lead">
          {t('moduleUnavailable.lead')}
        </p>

        <ul className="billing-module-unavailable__list">
          <li>
            <MailOutline aria-hidden />
            <span>
              {t('moduleUnavailable.emergencyBefore')}
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              {t('moduleUnavailable.emergencyAfter')}
            </span>
          </li>
          <li>
            <Smartphone aria-hidden />
            <span>{t('moduleUnavailable.mobileHint')}</span>
          </li>
        </ul>

        <button
          type="button"
          className="billing-module-unavailable__retry"
          onClick={handleRetry}
          disabled={isRefreshing}
        >
          {isRefreshing
            ? t('moduleUnavailable.retrying')
            : t('moduleUnavailable.retryButton')}
        </button>
      </div>
    </div>
  );
};

export default BillingModuleUnavailable;
